import { createTheme } from '@mui/material/styles';

// Create a theme instance.
const theme = createTheme({
  // Customize your theme here...
});

export default theme;